export enum BudgetExperimentStatuses {
  Draft = 0,
  Pending = 1,
  Approved = 2,
  Rejected = 3,
}
